import React, { useCallback, useState } from 'react';
import { SwitchTransition } from 'react-transition-group';
import { useTranslation } from '../../utils/useTranslation';
import { Drawer, DrawerContent } from '../feedback/Drawer';
import { Button } from '../input/Button';
import { FormControl } from '../input/FormControl';
import { Input } from '../input/Input';
import { Flex } from '../layout/Flex';
import { TransitionSlideUp } from '../transition/TransitionSlideUp';
import { Typography } from '../typography/Typography';

interface AddProductDrawerProps {
    handleClose: VoidFunction;
    error?: Error;
    addProduct: (productLink: string) => void;
    loading: boolean;
    onChangeUrl: VoidFunction;
}

export const AddProductDrawer = (props: AddProductDrawerProps) => {
    const { handleClose, addProduct, error, loading, onChangeUrl } = props;
    const [step, setStep] = useState<'OPEN' | 'CLOSE'>('OPEN');
    const t = useTranslation();
    const [productLink, setProductLink] = useState('');

    const onClose = useCallback(() => {
        setStep('CLOSE');
        handleClose();
    }, [handleClose]);

    return (
        <SwitchTransition>
            <TransitionSlideUp key={step}>
                <Drawer onClose={onClose}>
                    <DrawerContent p={2} pt={0}>
                        <Typography variant="title3" weight="bold" py={2}>
                            Добавить товары
                        </Typography>
                        <Typography pb={1.5}>{t('Вы можете добавить ссылку на товар')}</Typography>
                        <Flex width="100%" direction="row" spacing={2} alignItems="center" pb={3}>
                            <FormControl
                                label="Ссылка на товар"
                                disabled={loading}
                                error={Boolean(error)}
                                message={error?.message}
                            >
                                <Input
                                    value={productLink}
                                    type="text"
                                    autoComplete="off"
                                    placeholder="https://"
                                    onChange={(e) => {
                                        setProductLink(e.currentTarget.value);
                                        onChangeUrl();
                                    }}
                                />
                            </FormControl>
                        </Flex>
                        <Button
                            width="100%"
                            disabled={loading}
                            onClick={() => addProduct(productLink)}
                        >
                            {t('Добавить')}
                        </Button>
                    </DrawerContent>
                </Drawer>
            </TransitionSlideUp>
        </SwitchTransition>
    );
};
